// src/store/unpairUi.ts
import Vue from 'vue';

interface UnpairUi {
    visible: boolean;
    deviceId: string;
    key: number;
    open(deviceId: string): void;
    close(): void;
    complete(deviceId?: string): void;
}

export const unpairUi = Vue.observable<UnpairUi>({
    visible: false,
    deviceId: '',
    key: 0,
    open(deviceId: string) {
        this.deviceId = deviceId ?? '';
        this.visible = true;
        this.key++; // force remount of the dialog
    },
    close() {
        this.visible = false;
        this.deviceId = '';
    },
    complete(deviceId?: string) {
        if (!this.visible) return;
        // Ignore completions for a different device than the one being unpaired.
        if (deviceId && this.deviceId && deviceId !== this.deviceId) return;
        this.close();
    },
});
